export default __webpack_public_path__ + "static/media/Filter 1.fba51f22.svg";